// src/router.js

import { createRouter, createWebHistory } from 'vue-router';

import workboard from './views/workboard.vue';
import shopSettings from './views/shopSettings.vue';
import products from './views/products.vue';
import singleProduct from './views/singleProduct.vue';
import orders from './views/orders.vue';
import singleOrder from './views/singleOrder.vue';
import userLogin from './views/login.vue';

import errorPage from './views/errorPage.vue';
// import isAuth from './components/isAuth'

const routes = [
    { 
        path: '/', 
        component: workboard, 
        name: 'workboard', 
        meta: { requiresAuth: true, authGroups: ['admin','seller'] },
        props: true
    },
    { 
        path: '/login', 
        component: userLogin, 
        name: 'userLogin', 
        meta: { requiresAuth: false, authGroups: ['guest'] },
        props: true
    },
    { 
        path: '/toolaud/pood', 
        component: shopSettings, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin'] },
        name: 'shopSettings', 
        props: true
    },
    { 
        path: '/toolaud/tooted', 
        component: products, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin'] },
        name: 'products', 
        props: true
    },
    { 
        path: '/toode/:idListing', 
        component: singleProduct, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin'] },
        name: 'singleProduct', 
        props: true
    },
    { 
        path: '/toolaud/tellimused', 
        component: orders, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin'] },
        name: 'orders', 
        props: true
    },
    { 
        path: '/tellimus/:idOrder/:idDeal', 
        component: singleOrder, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin', 'base'] },
        name: 'singleOrder', 
        props: true
    },
    { 
        path: '/veateade', 
        component: errorPage, 
        meta: { requiresAuth: true, authGroups: ['seller', 'admin', 'base'] },
        name: '403Page', 
        props: true
    },
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from, next) => {
    let isAuthenticated = false; // Default to false
    let userGroups = []; // Default to empty array

    try {
        const response = await fetch(process.env.VUE_APP_MAIN_URL + `/v2/roundtrip`, {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': 'salaTokken'
            },
            credentials: 'include',
        });

        const res = await response.json();
        isAuthenticated = res.isAuthenticated;
        userGroups = res.userGroups || []; // Assign user groups from response
    } catch (error) {
        console.error('Error fetching authentication status:', error);
    }

    // Set meta info dynamically based on authentication status
    to.meta.isAuthenticated = isAuthenticated;

    if (to.matched.some(record => record.meta.requiresAuth) && !isAuthenticated) {
        // Redirect to login if the route requires authentication and the user is not authenticated
        next('/login');
    } else if (to.matched.some(record => record.meta.requiresAuth === false) && isAuthenticated) {
        // Redirect to '/' if the route doesn't require authentication and the user is authenticated
        next('/');
    } else {
        const routeAuthGroups = to.meta.authGroups || []; // Get the route's authGroups

        // Check if the user's groups intersect with the route's authGroups
        const hasAccess = routeAuthGroups.length === 0 || 
            userGroups.some(group => routeAuthGroups.includes(group));

        if (!hasAccess) {
            // If no intersection, deny access and optionally redirect (e.g., to a 403 page)
            next('/veateade'); 
        } else {
            // Proceed to the route
            next();
        }
    }
});

export default router;
